import { Component, input } from "@angular/core";
import { StatisticsLine } from "src/models/estate/IResidenceSaleInArea";
import { SearchViewOptionsFilterModel } from "../../../estate-filter/search-filter-view-options/search-filter-view-options.model";
import { ThousandizePipe } from "ev-core";
import { PeriodDefinitionType } from "@models/map/market-filter.model";

@Component({
    selector: "statistics-priceassumption",
    imports: [ThousandizePipe],
    templateUrl: "./statistics-priceassumption.component.html",
    styleUrl: "../market-price-statistics/market-price-statistics.component.scss",
})
export class StatisticsPriceassumptionComponent {
    statistics = input.required<StatisticsLine>();
    searchViewOptions = input.required<SearchViewOptionsFilterModel>();
    showDetails = input.required<boolean>();
    isHeader = input.required<boolean>();

    periodType = PeriodDefinitionType;
}
